import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    badgeNoIcon: 'b b-grey-60 rounded-full bg-white <md:bg-op-70 p-2'
  }
} satisfies RecursivePartial<ProductConfig['badge']>
